import React from 'react';
// No hardcoded seed: every map must start from the operator's real
// position or from the data being edited — never from a fixed Tokyo Bay
// coordinate. Leaving this undefined keeps GoogleMap's Loading gate
// reachable until geolocation or the data-derived fallback resolves.
const MapContext = React.createContext({
    center: undefined,
    setCenter: undefined,
});
function MapProvider({ children }) {
    const [center, setCenter] = React.useState();
    const provided = { center, setCenter };
    return React.createElement(MapContext.Provider, { value: provided }, children);
}
export { MapContext, MapProvider };
